// todo - maybe rename to sometning more universal

import { ACTIONS, LOCAL_TEST_DATE } from '../../constants';

const getInitDate = () => {
  let actualDate = null;
  if (process.env.NODE_ENV !== 'production') {
    // local debug
    actualDate = new Date(LOCAL_TEST_DATE);
  } else if (window.fakeDate !== null && typeof window.fakeDate !== 'undefined') {
    // test fake
    actualDate = new Date(window.fakeDate);
  } else {
    // normal - server date
    actualDate = new Date(window.date);
  }
  return actualDate;
};

const initState = {
  grid: 4,
  width: 0,
  showUpBtn: false,
  menuVisible: false,
  menuOverlay: false,
  date: getInitDate(),
};

const resize = (state = initState, action) => {
  switch (action.type) {
    case ACTIONS.RESIZE_GRID:
      return {
        ...state,
        grid: action.grid,
      };
    case ACTIONS.RESIZE_WIDTH:
      return {
        ...state,
        width: action.width,
      };
    case ACTIONS.MENU_SWITCH:
      return {
        ...state,
        menuVisible: !state.menuVisible,
      };
    case ACTIONS.MENU_OVERLAY:
      return {
        ...state,
        menuVisible: (state.menuVisible && action.menuOverlay) ? false : state.menuVisible,
        menuOverlay: action.menuOverlay,
      };
    case ACTIONS.SHOW_UP_BTN:
      return {
        ...state,
        showUpBtn: action.showUpBtn,
      };
    default:
      return state;
  }
};

export default resize;



// WEBPACK FOOTER //
// ./src/redux/reducers/resize.js